import { apiRequest } from '@/utils/api-request';
import { Eval, EvalModel } from '@/types/evals-types';
import { useOrgStore } from '@/stores/org-store';
import { normalizeDeprecatedEvalModel } from '@/constants/llm-models';

export const getEvaluations = async (): Promise<Eval[]> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<Eval[]>({
    url: `/evaluations/${orgId}`,
    target: 'platform',
    method: 'GET',
  });

  const evaluations = response?.data as Eval[];

  // Normalize deprecated models - auto-update to Claude 4.5 for deprecated models
  return evaluations.map((evaluation) => {
    const normalizedModel = normalizeDeprecatedEvalModel(evaluation.model);
    return {
      ...evaluation,
      model: normalizedModel as EvalModel,
    };
  });
};

export const getEvaluationById = async (id: string): Promise<Eval> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;
  const response = await apiRequest<Eval>({
    url: `/evaluations/${orgId}/${id}`,
    target: 'platform',
    method: 'GET',
  });

  const evaluation = response?.data as Eval;

  // Normalize deprecated models - auto-update to Claude 4.5 for deprecated models
  const normalizedModel = normalizeDeprecatedEvalModel(evaluation.model);
  return {
    ...evaluation,
    model: normalizedModel as EvalModel,
  };
};
